import { Component, inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentService } from '@lib/services/documents/documents.service';
import { OuiButton } from 'omnium-ui/button';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiLoading } from 'omnium-ui/loading';
import { OuiSnackbarService } from 'omnium-ui/snackbar';

@Component({
  selector: 'app-document-renouvellement-manuel-dialog',
  standalone: true,
  imports: [OuiDialogModule, OuiButton, OuiIconModule, OuiLoading],
  templateUrl: './document-renouvellement-manuel-dialog.component.html',
  styleUrl: './document-renouvellement-manuel-dialog.component.scss',
})
export class DocumentRenouvellementManuelDialogComponent {
  private readonly dialogRef = inject(
    MatDialogRef<DocumentRenouvellementManuelDialogComponent>
  );
  private readonly snackbarService = inject(OuiSnackbarService);
  private readonly documentService = inject(DocumentService);

  readonly data = inject(MAT_DIALOG_DATA);

  readonly isLoading = signal<boolean>(false);

  async confirm() {
    try {
      this.isLoading.set(true);
      await this.documentService.setDocumentDateFinAtToday(this.data.documentId);
      this.isLoading.set(false);

      this.snackbarService.open('La demande de renouvellement à bien envoyé', 'success');
      this.dialogRef.close(true);
    } catch (er) {
      this.isLoading.set(false);
      this.snackbarService.open(
        'Une erreur est survenue lors de la demande de renouvellement',
        'error'
      );
      this.dialogRef.close(false);
    }
  }
}
